export enum CohortClassType {
  VIVO = 'VIVO',
  ONDEMAND = 'ONDEMAND',
}
